import React from 'react';
import styled from '@tanium/react-emotion';
import { DefinitionDescription } from './DefinitionDescription';
import { DefinitionTerm, DefinitionTermProps } from './DefinitionTerm';

const Row = styled('div')({ display: 'table-row' });

export interface Props {
  /**
   * The term to be displayed.
   */
  term: React.ReactNode;
  /**
   * The description for the term.
   */
  description: React.ReactNode;
  /**
   * Vertical Alignment of the term.
   */
  termVerticalAlign?: DefinitionTermProps['verticalAlign'];
}

export const DefinitionListItem = ({ term, description, termVerticalAlign }: Props) => (
  <Row>
    <DefinitionTerm verticalAlign={termVerticalAlign}>{term}</DefinitionTerm>
    <DefinitionDescription>{description}</DefinitionDescription>
  </Row>
);
